import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WebsitePage } from "@/features/website/WebsitePage";

const search = z.object({
  page: z.string().optional(),
});

export const Route = createFileRoute("/_app/website")({
  validateSearch: search,
  component: () => <WebsitePage search={Route.useSearch()} />,
});
